import { render, staticRenderFns } from "./AudioTranscriptionModal.vue?vue&type=template&id=4764fe13&scoped=true&"
import script from "./AudioTranscriptionModal.vue?vue&type=script&lang=js&"
export * from "./AudioTranscriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./AudioTranscriptionModal.vue?vue&type=style&index=0&id=4764fe13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4764fe13",
  null
  
)

export default component.exports